const getProcessedFareTrendsData = ({ date, departure, fareCalendarData }) => {
  const selectedDate = date || departure.yyyymmdd;

  const fareTrendsDataList = [];
  let position = 0;
  if (fareCalendarData && fareCalendarData.data) {
    Object.keys(fareCalendarData.data).forEach((key, index) => {
      if (fareCalendarData.data[key] && fareCalendarData.data[key].p) {
        fareTrendsDataList.push({
          date: key,
          price: fareCalendarData.data[key].p
        });
      }
      if (key === selectedDate) {
        position = index;
      }
    });
  }
  const len = fareTrendsDataList.length;
  let endIndex = position + 8;
  if (endIndex > len) {
    endIndex = len;
  }
  let startIndex = endIndex - 15;
  if (startIndex < 0) {
    startIndex = 0;
    endIndex = 15;
  }
  const fareList = fareTrendsDataList.slice(startIndex, endIndex);
  return fareList;
};

export default getProcessedFareTrendsData;
